import { render, staticRenderFns } from "./StartConversation.vue?vue&type=template&id=423146d2&scoped=true"
import script from "./StartConversation.vue?vue&type=script&lang=js"
export * from "./StartConversation.vue?vue&type=script&lang=js"
import style0 from "./StartConversation.vue?vue&type=style&index=0&id=423146d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423146d2",
  null
  
)

export default component.exports